import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {useNavigate, useParams} from 'react-router-dom'
import {Button} from '_core'
import {isDisableOrderEdit, ViewOrder} from 'app/features/orders/models/OrderState'
import {RootState} from 'setup'
import {orderFulfillmentStatusTypes, orderStatus} from 'app/features/orders/models'
import {fulfillmentStatusTypes, paymentStatusTypes} from 'app/constant'

interface Props {}

export const CreateEdit: React.FC<Props> = () => {
  const {orderId} = useParams<any>()
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)
  const history = useNavigate()

  const handleClick = async () => {
    history(`/orders/${orderId}/edit`)
  }

  const isOrderEdit = useMemo(() => {
    if (
      order.fulfillmentStatus === orderStatus.restocked &&
      order.financialStatus === paymentStatusTypes.refunded
    ) {
      return true
    }
    if (
      order.financialStatus === paymentStatusTypes.refunded &&
      order.fulfillmentStatus === fulfillmentStatusTypes.unfulfilled
    ) {
      return true
    }
    return false
  }, [order.fulfillmentStatus, order.financialStatus])

  if (isDisableOrderEdit(order)) {
    return null
  }

  return (
    <>
      {order.fulfillmentStatus !== orderFulfillmentStatusTypes.readyToFulfill &&
        order.fulfillmentStatus !== orderFulfillmentStatusTypes.fulfilled &&
        order.fulfillmentStatus !== orderFulfillmentStatusTypes.partial &&
        !isOrderEdit && (
          <div className='me-5'>
            <Button
              id='btnOrderCancel'
              title='Edit Order'
              isSubmitting={false}
              className='btn explore-btn-outline border'
              onClick={handleClick}
            />
          </div>
        )}
    </>
  )
}

export default CreateEdit
